<script setup>

    const phone_show_status = ref(false);
    const phone_value = computed(() => {
        if( phone_show_status.value == false ){
            return '+7-812-98...'
        }
        else if( phone_show_status.value !== false ){
            return phones[1]
        }
    })
    // Выбор рандомного номера из списка
    const phones = [
        '+7-952-288-59-85',
        '+7-812-987-76-31',
        '+7-812-988-59-85',
        '+7-952-287-76-31',
    ]

    const RECAPTCHA_PUBLIC = '6LehhpcqAAAAAPeAFBjLDowlFKhwp9vjStWtgGlF'
    const click_show = () => {
        grecaptcha.ready( () => {
            grecaptcha.execute( RECAPTCHA_PUBLIC, {action: 'submit'}).then( async (token) =>  {
                const response = await fetch('/api/forms/phone_show', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token
                    }),
                });
                const result = await response.json();
                console.log('result', result);
                if (result.status === 'success') {
                    phone_show_status.value = true
                    ym(54350782,'reachGoal','show_phone')
                }
            })
        })
    }

</script>
<template>
    <div class="flex items-center gap-8 pt-3">
        <div class="flex items-center gap-2 w-1/3">
            <img src="/public/img/icons/phone.svg" alt="" />
            <p class="font-medium">ТЕЛЕФОН</p>
        </div>
        <div class="flex w-2/3 justify-end">
            <p class="text-brand-grey truncate" :class="phone_show_status ? 'w-auto' : 'w-20'">
                <a href="tel:78129877331" class="text-base">{{ phone_value }}</a>
            </p>
            <p class="text-brand-blue underline cursor-pointer text-base ms-1" v-if="!phone_show_status" @click="click_show">
                Показать
            </p>
        </div>
    </div>
</template>